<template>
  <el-row :gutter="20" class="image-row" style="padding-bottom: 10px;">
    <el-col v-for="(item, index) in images" :key="index" :xs="12" :sm="8" :md="6">
      <div class="grid-item-box">
        <div class="image-title" :class="{ 'is-required': item.required }">{{ item.name }}</div>
        <ouer-uploader v-model="images[index]" :has-error="item.error" :err-message="`请上传${item.name}`" :disabled="disabled" @change="onChange" />
      </div>
    </el-col>
  </el-row>
</template>

<script>
import OuerUploader from '@/components/OuerUploader'

export default {
  name: 'ShopPhotos',
  components: { OuerUploader },
  emits: ['input'],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    detail: {
      type: Object,
      default: () => {}
    },
    disabled: Boolean
  },
  data() {
    return {
      images: [
        { field: 'doorPhoto', name: '店铺门头照', url: '', file: null, required: true },
        { field: 'cashierPhoto', name: '收银台照', url: '', file: null },
        { field: 'premisePhoto1', name: '经营场所内景照一', url: '', file: null },
        { field: 'premisePhoto2', name: '经营场所内景照二', url: '', file: null },
        { field: 'licencePhoto', name: '营业执照照片', url: '', file: null },
        { field: 'openAccountPhoto', name: '开户许可证照片', url: '', file: null },
        { field: 'legalCardPhoto1', name: '法人身份证正面照', url: '', file: null },
        { field: 'legalCardPhoto2', name: '法人身份证反面照', url: '', file: null },
        { field: 'bankCardFront', name: '银行卡正面照', url: '', file: null },
        { field: 'bankCardBack', name: '银行卡反面照', url: '', file: null },
        { field: 'certificatePhoto', name: '资质照片', url: '', file: null }
      ]
    }
  },
  watch: {
    detail: {
      deep: true,
      handler(newValue) {
        if (newValue) this.loadData()
      }
    }
  },
  methods: {
    loadData() {
      this.images = this.images.map(image => {
        if (image.field.startsWith('premisePhoto') && this.detail.premisePhoto) {
          if (this.detail.premisePhoto) {
            const photo = this.detail.premisePhoto.split(',')
            image.url = photo[image.field === 'premisePhoto1' ? 0 : 1]
          }
        } else if (image.field.startsWith('legalCardPhoto') && this.detail.legalCardPhoto) {
          if (this.detail.legalCardPhoto) {
            const photo = this.detail.legalCardPhoto.split(',')
            image.url = photo[image.field === 'legalCardPhoto1' ? 0 : 1]
          }
        } else {
          image.url = this.detail[image.field]
        }
        image.file = null
        return image
      })
    },
    async onChange() {
      const images = this.images.filter(item => item.changed)
      this.$emit('input', images)
      try {
        await this.validate()
      } catch (error) {
        console.warn(error)
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (!this.images[0]?.url) {
          this.images[0].error = true
          reject('请上传店铺门头照')
        } else {
          this.images[0].error = false
          resolve()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-item-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .image-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    &.is-required::before {
      content: '*';
      color: #ff4949;
      margin-right: 4px;
    }
  }
}
</style>
